export const viewTitle = "Журнал сообщений об ошибке";
export const viewUniqKey = "bug-reports";
